/**
 * Pop-up de regalo — Apodemia
 *
 * Muestra un pop-up (esquina inferior en escritorio, bottom sheet en móvil)
 * ofreciendo un producto de regalo o un formulario de suscripción. Con producto,
 * el CTA lo añade al carrito; sin producto, registra el email como newsletter.
 *
 * Reglas:
 *  - Aparece tras `data-delay` segundos si está activo, no se ha cerrado/mostrado
 *    ya (según frecuencia), el regalo NO está ya en el carrito, y el carrito
 *    alcanza el mínimo `data-min-cents` (0 = siempre).
 *  - Frecuencia: 'session' (una vez por sesión) · 'day' (una vez cada 24h) ·
 *    'always' (cada carga, salvo si ya está en el carrito o cerrado esta sesión).
 *  - El precio 0 lo aplica un descuento automático de Shopify o una variante a 0€.
 *
 * Testing: window.iuropGift.show() / .close() / .reset() / .debug()
 */
(function () {
  'use strict';

  var SNOOZE_KEY = 'iurop:gift:snooze-until';
  var SESSION_KEY = 'iurop:gift:session-dismissed';

  var qs = function (sel, root) { return (root || document).querySelector(sel); };
  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var now = function () { return Date.now(); };

  var el = function () { return qs('[data-gift-popup]'); };
  var isEnabled = function (n) { return n && n.dataset.enabled === 'true'; };

  function open() {
    var n = el();
    if (!n) return;
    n.classList.add('is-open');
    n.setAttribute('aria-hidden', 'false');
    if (window.matchMedia('(max-width: 749px)').matches) {
      document.body.classList.add('apodemia-gift-open');
    }
  }

  function close() {
    var n = el();
    if (!n) return;
    n.classList.remove('is-open');
    n.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('apodemia-gift-open');
    dismiss(n);
  }

  // Marca según frecuencia para no reaparecer.
  function dismiss(n) {
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (_) {}
    var freq = n.dataset.frequency || 'session';
    if (freq === 'day') {
      try { localStorage.setItem(SNOOZE_KEY, String(now() + 24 * 60 * 60 * 1000)); } catch (_) {}
    }
  }

  function dismissedThisSession() {
    try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch (_) { return false; }
  }
  function snoozed() {
    try {
      var until = parseInt(localStorage.getItem(SNOOZE_KEY), 10);
      return until && until > now();
    } catch (_) { return false; }
  }

  // ¿El regalo ya está en el carrito? (por variante o por la propiedad _regalo)
  function giftInCart(cart, variantId) {
    if (!variantId) return false;
    if (!cart || !cart.items) return false;
    return cart.items.some(function (it) {
      if (it.variant_id === variantId) return true;
      return it.properties && it.properties._regalo;
    });
  }

  function decideAndShow() {
    var n = el();
    if (!isEnabled(n)) return;
    if (document.querySelector('[data-threshold-gift-popup][data-enabled="true"]')) return;
    if (dismissedThisSession() || snoozed()) return;

    var variantId = parseInt(n.dataset.variantId, 10);
    var minCents = parseInt(n.dataset.minCents, 10) || 0;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (giftInCart(cart, variantId)) return;              // ya lo tiene
        if (minCents > 0 && cart.total_price < minCents) return; // no alcanza el mínimo
        var delay = (parseInt(n.dataset.delay, 10) || 6) * 1000;
        setTimeout(open, delay);
      })
      .catch(function () {
        // Sin datos de carrito: si no hay mínimo, muestra igualmente.
        if ((parseInt(n.dataset.minCents, 10) || 0) === 0) {
          setTimeout(open, (parseInt(n.dataset.delay, 10) || 6) * 1000);
        }
      });
  }

  // Añadir el regalo al carrito y abrir el sidecart. Sin producto, cerrar el aviso.
  function addGift() {
    var n = el();
    if (!n) return;
    var btn = qs('[data-gift-add]', n);
    var variantId = parseInt(n.dataset.variantId, 10);
    if (btn && btn.disabled) return;
    if (!variantId) {
      close();
      return;
    }
    if (btn) btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { _regalo: n.dataset.label || 'Regalo' } }]
      })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
        );
        close();
      })
      .catch(function () { if (btn) btn.disabled = false; });
  }

  function bind() {
    var n = el();
    if (!n) return;
    qsa('[data-gift-close]', n).forEach(function (c) { c.addEventListener('click', close); });
    var add = qs('[data-gift-add]', n);
    if (add) add.addEventListener('click', addGift);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && n.classList.contains('is-open')) close();
    });
  }

  function init() {
    var n = el();
    if (!n) return;
    bind();
    if (qs('[data-gift-newsletter-result]', n)) {
      open();
      return;
    }
    decideAndShow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.iuropGift = {
    show: open,
    close: close,
    reset: function () {
      try {
        localStorage.removeItem(SNOOZE_KEY);
        sessionStorage.removeItem(SESSION_KEY);
      } catch (_) {}
    },
    debug: function () {
      var n = el();
      return {
        enabled: isEnabled(n),
        variantId: n && parseInt(n.dataset.variantId, 10),
        minCents: n && parseInt(n.dataset.minCents, 10),
        frequency: n && n.dataset.frequency,
        dismissedThisSession: dismissedThisSession(),
        snoozed: snoozed()
      };
    }
  };
})();
